import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import { Link } from "react-router-dom";
// import {encrypt,decrypt} from "../hooks/crypt"
// import show_pass from "../hooks/auth";
import VerifyForm from "../components/Form/VerifyForm";
const Verify = () => {
  return (
    <React.Fragment>
      <SEO title="Verify | ICSI 2023" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Verify Your Token"
        content="Verify"
        contentTwo="Verify Your Token"
        linkage="/"
      />

      <EmptyTwo>
        <div classNameName="entry-header">
          <h2>Authentication</h2>
          <div className="authen">
            <p className="access">For accessing Registration Page</p>
          </div>
          <br />
          <br />
          <h5>
            Please fill in the TOKEN which was sent to you in the notification
            email.
          </h5>
          <p>
            If there is any problem with the verification process, please
            contact the ICSI Conference Secretariat via email at <a href='mailto:icsi2024@iasei.org'>icsi2024@iasei.org</a> .
          </p>
          <br></br>
          <div className="verify-form">
            <VerifyForm></VerifyForm>
          </div>
          {/* <div className="pub-btn">
            <p>
              <br></br>
              <br></br>
              <br></br>

              <h5>
                If you do not published any article at ICSI2022, please click
                the button below for Public Registration.
              </h5>
            </p>
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/registration_pub"}
            >
              Public Registration
            </Link>
          </div> */}
        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Verify;
